import { Navigate, Route, Routes } from "react-router-dom"
import { useSession } from "./auth/SessionProvider.tsx"
import { useT } from "./i18n/index.tsx"
import { AppShell } from "./components/AppShell.tsx"
import { LoginPage } from "./pages/LoginPage.tsx"
import { DashboardPage } from "./pages/DashboardPage.tsx"
import { CaseListPage } from "./pages/CaseListPage.tsx"
import { CaseNewPage } from "./pages/CaseNewPage.tsx"
import { CaseDetailPage } from "./pages/CaseDetailPage.tsx"
import { ScanPage } from "./pages/ScanPage.tsx"
import { OrphanCargoPage } from "./pages/OrphanCargoPage.tsx"
import { AppPairInfoPage } from "./pages/AppPairInfoPage.tsx"
import { ShipmentListPage } from "./pages/ShipmentListPage.tsx"
import { ShipmentDetailPage } from "./pages/ShipmentDetailPage.tsx"
import { ItemMasterPage } from "./pages/ItemMasterPage.tsx"
import { SettingsPage } from "./pages/SettingsPage.tsx"
import { PasswordPage } from "./pages/PasswordPage.tsx"
import { ManualPage } from "./pages/ManualPage.tsx"

export function App() {
  const { user, loading } = useSession()
  const t = useT()

  if (loading) {
    return (
      <div className="login">
        <p className="muted">{t("common.loading")}</p>
      </div>
    )
  }

  if (!user) return <LoginPage />

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/cases" element={<CaseListPage />} />
        <Route path="/cases/new" element={<CaseNewPage />} />
        <Route path="/cases/:id" element={<CaseDetailPage />} />
        <Route path="/scan" element={<ScanPage />} />
        {/* 무적화물만 보는 화면. 잇기는 입고 스캔 화면과 같은 것을 쓴다. */}
        <Route path="/orphans" element={<OrphanCargoPage />} />
        {/* 기기 등록 QR 을 브라우저가 열었을 때. 앱이 읽는 주소라는 것을 알려 준다. */}
        <Route path="/app/pair" element={<AppPairInfoPage />} />
        <Route path="/shipments" element={<ShipmentListPage />} />
        <Route path="/shipments/:id" element={<ShipmentDetailPage />} />
        <Route path="/item-masters" element={<ItemMasterPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/password" element={<PasswordPage />} />
        <Route path="/manual" element={<ManualPage />} />
        <Route path="/manual/:slug" element={<ManualPage />} />
        {/* 모르는 경로는 할 일 화면으로. 조용한 404 보다 낫다. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  )
}

